// System Module Label Translations
// This file contains all text labels used throughout the system screens
// It includes Italian and English translations for all user-facing strings

export const systemLabels = {
  it: {
    // Breadcrumb translations
    home: 'Home',
    admin: 'Amministrazione',
    security: 'Sicurezza',
    rightsTree: 'Albero dei diritti',
    
    // Screen specific translations
    clickToAddNewParentNode: 'Clicca per aggiungere un nuovo nodo padre',
    newRight: 'Nuovo diritto',
    confirmDeleteRight: 'Sei sicuro di voler eliminare il diritto "{{name}}"?',
    missingNameForRight: 'Manca il nome per il diritto #{{index}}',
    confirm: 'Conferma',
    cancel: 'Annulla',
    unnamed: 'Senza nome',
    
    // Common labels
    name: 'Nome',
    description: 'Descrizione',
    actions: 'Azioni',
    edit: 'Modifica',
    add: 'Aggiungi',
    delete: 'Elimina',
    save: 'Salva',
    saving: 'Salvataggio in corso...',
    savingNewData: 'Salvataggio dei nuovi dati...',
    success: 'Successo',
    error: 'Errore',
    nothingToSave: 'Nulla da salvare',
    nothingToSaveMessage: 'Non ci sono modifiche da salvare.',
    savedSussessfullyWithNumberMessage: 'Salvati con successo {{number}} elementi.',
    saveThisData: 'Salva questi dati',
    switchToTreeView: 'Passa alla vista ad albero',
    switchToListView: 'Passa alla vista lista',
    
    // Organizational Chart specific translations
    businessUnitNotFound: 'Business unit non trovata',
    goToBusinessUnit: 'Vai alle business unit',
    chooseUser: 'Scegli l\'utente',
    user: 'Utente',
    search: 'Cerca',
    email: 'E-Mail',
    close: 'Chiudi',
    ok: 'OK',
    role: 'Ruolo',
    from: 'Da',
    to: 'A'
  },
  
  en: {
    // Breadcrumb translations
    home: 'Home',
    admin: 'Administration',
    security: 'Security',
    rightsTree: 'Rights Tree',
    
    // Screen specific translations
    clickToAddNewParentNode: 'Click to add a new parent node',
    newRight: 'New right',
    confirmDeleteRight: 'Are you sure you want to delete the right "{{name}}"?',
    missingNameForRight: 'Missing name for right #{{index}}',
    confirm: 'Confirm',
    cancel: 'Cancel',
    unnamed: 'Unnamed',
    
    // Common labels
    name: 'Name',
    description: 'Description',
    actions: 'Actions',
    edit: 'Edit',
    add: 'Add',
    delete: 'Delete',
    save: 'Save',
    saving: 'Saving...',
    savingNewData: 'Saving new data...',
    success: 'Success',
    error: 'Error',
    nothingToSave: 'Nothing to save',
    nothingToSaveMessage: 'There are no changes to save.',
    savedSussessfullyWithNumberMessage: 'Successfully saved {{number}} items.',
    saveThisData: 'Save this data',
    switchToTreeView: 'Switch to tree view',
    switchToListView: 'Switch to list view',
    
    // Organizational Chart specific translations
    businessUnitNotFound: 'Business unit not found',
    goToBusinessUnit: 'Go to business unit',
    chooseUser: 'Choose the user',
    user: 'User',
    search: 'Search',
    email: 'E-Mail',
    close: 'Close',
    ok: 'OK',
    role: 'Role',
    from: 'From',
    to: 'To'
  }
}; 